// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__1yPjQ","spinner":"spinner_spinner__6LOe0","flex":"spinner_flex__q1YV0"};